import React from 'react';
// export function SidebarItem({ title, icon: IconComponent, isActive, onClick }) {
//   return (
//     <li 
//       className={`flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-f3f8ff rounded-md transition-colors
//         ${isActive ? 'bg-blue-50' : ''}`}
//       onClick={onClick}
//     >
//       {IconComponent && <IconComponent className="w-4 h-4 text-667085" />}
//       <span className="text-gray-700">{title}</span>
//     </li>
//   );
// }

export function SidebarItem({ title, icon: IconComponent, isActive = false, onClick, badge }) {
  return (
    <li 
      className={`group flex items-center justify-between mx-2.5 pl-1 py-2.5 cursor-pointer rounded-md transition-all duration-200 ease-in-out
        ${isActive 
          ? 'bg-report-side-bar-hover-element-bg text-report-side-bar-hover-text-colour shadow-sm' 
          : 'reports-normal-text-colour hover:bg-gray-200'
        }`}
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        <IconComponent className={`w-4 h-4 transition-colors duration-200 ${
          isActive 
            ? 'fill-report-side-bar-hover-text-colour text-white ' 
            : 'text-normal-text-colour group-hover:bg-gray-200'
        }`} />
        <span className="text-sm">{title}</span>
      </div>
      {badge && (
        <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded-full">
          {badge}
        </span>
      )}
    </li>
  );
}